import React from 'react'
import Frame from './Frame'
import Port from './Port'
import DoorLayer from './DoorLayer'
import WindowsLayer from './WindowsLayer'

function PortImage (props) {

  return (
    <figure className={'port-image'}>
      <div className={'scene'}>
        <Frame/>
        <Port>
          <WindowsLayer name={'windows'} className={'port-image__windows'}/>
          <DoorLayer name={'door'} className={'port-image__door'}/>
        </Port>
      </div>
    </figure>
  )
}

export default PortImage